module.exports = __webpack_public_path__ + "static/media/class_job_024.532cf342.svg";